import { render, staticRenderFns } from "./SquatationPos.vue?vue&type=template&id=77c16d32&scoped=true"
import script from "./SquatationPos.vue?vue&type=script&lang=js"
export * from "./SquatationPos.vue?vue&type=script&lang=js"
import style0 from "./SquatationPos.vue?vue&type=style&index=0&id=77c16d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c16d32",
  null
  
)

export default component.exports